import { NEC } from 'constants/globalConstants';
import { format } from 'date-fns';
import { get } from 'lodash';

/* istanbul ignore file */
type OrganismeListProps = {
  LIBELLE_IDENTIFIANT: string;
  NOM_SOUSCRIPTEUR: string;
  NUM_POLICE: string;
  id: string;
};
export const mappedOrganismeList = (organismeList: OrganismeListProps[]) => {
  const results = organismeList
    ? organismeList.map((item) => {
        return {
          label: item?.NOM_SOUSCRIPTEUR,
          name: item?.NUM_POLICE,
        };
      })
    : [];
  return results;
};
interface mandatoryFilesListType {
  CodeDocument: string;
  Id: string;
  LibelleDocument: string;
  NumIdentification: null | string;
  NumPolice: null | string;
}
export const mandatoryFilesListMapping = (
  filesNames: mandatoryFilesListType[],
) => {
  const result = filesNames
    ? filesNames.map((item, key) => {
        return {
          icon: key === 0 ? 'cardIcon' : 'cardIcon2',
          title: item.LibelleDocument,
        };
      })
    : [];
  return result;
};

interface foldersTypeListType {
  Alt: null | string;
  Code: string;
  Id: null | string;
  Libelle: string;
  TypesSoins: [];
  Visuel: string;
}
export const foldersTypeListMapping = (foldersList: foldersTypeListType[]) => {
  const result = foldersList
    ? foldersList.map((item) => {
        return {
          icon: item.Visuel.split('.')[0],
          name: item.Code,
          label: item.Libelle,
        };
      })
    : [];
  return result;
};

interface concernedPeopleListType {
  NomPrenomAdherent: string;
  Categorie: string;
}
export const concernedPeopleMapping = (
  concernedPeople: concernedPeopleListType[],
) => {
  const result = concernedPeople
    ? concernedPeople.map((item) => {
        return {
          name: item.NomPrenomAdherent,
          label: item.NomPrenomAdherent,
          secondTitle: concernedPeopleCat(item.Categorie),
        };
      })
    : [];
  return result;
};
const concernedPeopleCat = (person: string) => {
  let title;
  if (person === 'AS') {
    title = "L'ASSURÉ(E) LUI MÊME";
  } else if (person.charAt(0) === 'C') {
    title = 'CONJOINT';
  } else title = 'ENFANT';
  return title;
};
interface documentFilesType {
  Code: string;
  Libelle: string;
}
export const documentFilesMapping = (documentFiles: documentFilesType[]) => {
  const result = documentFiles
    ? documentFiles.map((item) => {
        return {
          icon: 'fileIcon2',
          title: item.Libelle,
        };
      })
    : [];
  return result;
};

export const createFolderMapping = (
  values: any,
  { selectedOrganisme, concernedPeople, mandatoryFiles }: any,
) => {
  const categorie = concernedPeople?.find(
    (item: any) => item.NomPrenomAdherent === values.concernedPeople,
  );
  const obj = {
    Canal: NEC,
    CanalDemande: NEC,
    DateConsultation: format(Date.parse(values.dateConsultation), 'dd/MM/yyyy'),
    Email: values.email,
    Files: values.documentFiles.map((element: any, index: number) => ({
      FileName: `image${index + 1}.${element.file.type.split('/')[1]}`,
      FileType: element.file.type,
      FileSize: element.file.size,
      Filecontent: element.data.replace('data:', '').replace(/^.+,/, ''),
    })),
    Frais: values.fraisEngagement,
    Gsm: values.telNumber,
    IdAdherent:
      values.organisme?.replace('/', '_') +
      'ID' +
      selectedOrganisme?.id +
      'CAS',
    IdPersonneACharge:
      values.organisme?.replace('/', '_') +
      'ID' +
      selectedOrganisme?.id +
      'C' +
      categorie?.Categorie,
    MondatoryFiles: values.mandatoryFiles.map(
      (element: any, index: number) => ({
        FileName: `document${index + 1}.${element.file.type.split('/')[1]}`,
        FileType: element.file.type,
        FileSize: element.file.size,
        Filecontent: element.data.replace('data:', '').replace(/^.+,/, ''),
        IDFichier: mandatoryFiles[index].Id,
        libelle: mandatoryFiles[index].LibelleDocument,
      }),
    ),
    NomPrenomAdherent: values.concernedPeople,
    NomPrenomAssurePrincipal: get(
      concernedPeople.find((item: any) => {
        return item.Categorie === 'AS';
      }),
      'NomPrenomAdherent',
      '',
    ),
    NumIdentification: selectedOrganisme?.id,
    NumPolice: values.organisme?.replace('/', '_'),
    TypeDossier: values.typeDossier,
    sessionsId: values.sessionsId,
    token: values.token,
  };
  return obj;
};
